import React from 'react';

import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const TopDepartmentsSalesChart = ({ data = [], height = 300 }) => {
  const defaultData = [
    { name: 'Sales', amount: 450000 },
    { name: 'Marketing', amount: 320000 },
    { name: 'Business Dev', amount: 280000 },
    { name: 'Customer Success', amount: 220000 },
    { name: 'Product', amount: 180000 },
    { name: 'Operations', amount: 150000 },
  ];

  const chartData = data.length > 0 ? data : defaultData;

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length > 0) {
      const data = payload[0].payload;
      return (
        <div
          style={{
            background: 'white',
            padding: '12px',
            border: '1px solid #e0e0e0',
            borderRadius: '6px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            fontSize: '12px',
          }}
        >
          <p style={{ margin: 0, color: '#333', fontSize: '14px', fontWeight: '600' }}>
            {data.name}
          </p>
          <p style={{ margin: '4px 0 0 0', color: '#666', fontSize: '13px' }}>
            Revenue: ${payload[0].value?.toLocaleString()}
          </p>
        </div>
      );
    }
    return null;
  };

  const formatXAxisLabel = (value) => {
    if (value >= 1000000) {
      return `$${(value / 1000000).toFixed(1)}M`;
    } else if (value >= 1000) {
      return `$${value / 1000}k`;
    }
    return `$${value}`;
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        layout="vertical"
        data={chartData}
        margin={{ top: 10, right: 30, left: 10, bottom: 5 }}
      >
        <XAxis
          type="number"
          tick={{ fontSize: 12, fill: '#666' }}
          axisLine={false}
          tickLine={false}
          tickFormatter={formatXAxisLabel}
        />
        <YAxis
          dataKey="name"
          type="category"
          width={100}
          tick={{ fontSize: 12, fill: '#666' }}
          axisLine={false}
          tickLine={false}
        />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="amount" fill="#2B7FFF" radius={[0, 4, 4, 0]} name="Revenue" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TopDepartmentsSalesChart;
